export default __webpack_public_path__ + "img/pin_icons/revolving_door_w.svg";